import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import PaginationAdvanced from "../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import Joyride from "react-joyride";
import CompanyStatusCheck from "./CompanyStatusCheck";
import moment from "moment";
import Search from "./Search";
import { Modal } from "react-bootstrap";
import SentSMS from "./SentSMS";

import Index from "./Index";
import { fetchRookeryStatusInfo, fetchCampaignSMS } from "../actions/index";

export class CampaignSMSIndex extends Index {
  static propTypes = {
    fetchCampaignSMS: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    sms: PropTypes.object,
    fetchRookeryStatusInfo: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state.sms =  null;
    this.state.showModal = false;
    this.state.enabled = true;
  }

  checkRookeryStatus() {
    this.props
      .fetchRookeryStatusInfo()
      .then(response => {
        if (response.payload.data.data.rookery_enabled) {
          this.fetchData();
        } else {
          this.setState({ enabled: false });
        }
      });
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchCampaignSMS(
      this.props.match.params.id,
      this.serialize(newQueries)
    );
    this.props.history.push(`/campaigns/${this.props.match.params.id}/sms${this.serialize(newQueries)}`);
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal() {
    this.setState({ showModal: true });
  }

  open(e) {
    let sms = {
      phone: e.target.dataset.phone,
      first_name: e.target.dataset.first_name,
      last_name: e.target.dataset.last_name,
      sms_template_name: e.target.dataset.sms_template_name,
      body_text: e.target.dataset.body_text
    };
    this.setState({ sms: sms });
    this.openModal();
  }

  renderCampaignSMS() {
    if (!this.props.sms.data) {
      return (
        <tr>
          <td colSpan={10}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.sms.data.length == 0) {
      return (
        <tr>
          <td colSpan={10}>
            <div className="well well-lg text-center">
              You have no SMS.&nbsp;
            </div>
          </td>
        </tr>
      );
    }

    return this.props.sms.data.map(sms => {
      return (
        <tr key={sms.id}>
          <td>{moment(sms.created_at).format("MM/DD/YYYY h:mm:ss A")}</td>
          <td>{sms.phone}</td>
          <td>{sms.first_name}</td>
          <td>{sms.last_name}</td>
          <td>{sms.sms_template_name}</td>
          <td className="text-right">
            <button
              className="btn btn-xs btn-inverse pull-right"
              data-phone={sms.phone}
              data-first_name={sms.first_name}
              data-last_name={sms.last_name}
              data-sms_template_name={sms.sms_template_name}
              data-body_text={sms.body_text}
              onClick={this.open.bind(this)}
            >
              Details
            </button>
          </td>
        </tr>
      );
    });
  }

  startTour() {
    this.setState({
      steps: [
        {
          content:
            "The Workflow SMS page lists the SMS you have sent from your workflows.",
          target: ".help_icon_smaller",
          placement: "bottom",
          disableBeacon: true
        }
      ],
      startTour: true
    });
  }

  render() {
    let count = 0;
    if (!this.props.sms || !this.props.sms.meta) {
      return (
        <div className="vertical-center">
          <CSSTransitionGroup
            transitionName="spinner"
            transitionAppear={true}
            transitionAppearTimeout={500}
          >
            <i className="fa fa-refresh fa-4x fa-spin" />
          </CSSTransitionGroup>
        </div>
      );
    }
    count = this.props.sms.meta.count;
    if (this.state.enabled == true) {
      return (
        <div className="sms">
          <CompanyStatusCheck history={this.props.history} />
          <Joyride
            run={this.state.startTour}
            continuous={true}
            steps={this.state.steps}
            showSkipButton={true}
            showProgress={true}
            scrollToSteps={false}
            callback={this.tourCallback.bind(this)}
          />
          <div className="row">
            <h1>
              {this.props.sms.meta.campaign_name} SMS
              <button
                bsStyle="default"
                className="btn btn-sm btn-primary help_icon_smaller"
                onClick={this.startTour.bind(this)}
              >
                ?
              </button>
              <div className="pull-right">
                <Search
                  handleSearch={this.handleSearch.bind(this)}
                  searchStr={this.state.search}
                />
              </div>
            </h1>
          </div>
          <div className="row">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th
                    className={`sms_date ${this.indicateSorting("created_at")}`}
                    data-sort="created_at"
                    onClick={this.handleOrder.bind(this)}
                  >
                    Sent Date
                  </th>
                  <th
                    className={`sms_phone ${this.indicateSorting("phone")}`}
                    data-sort="phone"
                    onClick={this.handleOrder.bind(this)}
                  >
                    Phone
                  </th>
                  <th
                    className={`sms_first_name ${this.indicateSorting(
                      "first_name"
                    )}`}
                    data-sort="first_name"
                    onClick={this.handleOrder.bind(this)}
                  >
                    First Name
                  </th>
                  <th
                    className={`sms_last_name ${this.indicateSorting(
                      "last_name"
                    )}`}
                    data-sort="last_name"
                    onClick={this.handleOrder.bind(this)}
                  >
                    Last Name
                  </th>
                  <th className={`sms_template_name`}>Template</th>
                </tr>
              </thead>
              <tbody>{this.renderCampaignSMS()}</tbody>
            </table>
          </div>
          <div className="row text-right">
            <PaginationAdvanced
              handle={this.handlePagination.bind(this)}
              total={count}
              page={this.state.page}
              per_page={this.state.per_page}
            />
          </div>

          <Modal
            show={this.state.showModal}
            onHide={this.closeModal.bind(this)}
            backdrop="static"
            keyboard={false}
            autoFocus={true}
            enforceFocus={true}
          >
            <Modal.Header closeButton={true}>
              <Modal.Title id="contained-modal-title-lg">SMS</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <SentSMS sms={this.state.sms} />
            </Modal.Body>
          </Modal>
        </div>
      );
    } else {
      return (
        <div className="templates_index">
          <CompanyStatusCheck history={this.props.history} />
          <Joyride
            run={this.state.startTour}
            continuous={true}
            steps={this.state.steps}
            showSkipButton={true}
            showProgress={true}
            scrollToSteps={false}
            callback={this.tourCallback.bind(this)}
          />
          <div className="row">
            <h1>
              {this.props.sms.meta.campaign_name} SMS
              <button
                bsStyle="default"
                className="btn btn-sm btn-primary help_icon_smaller"
                onClick={this.startTour.bind(this)}
              >
                ?
              </button>
            </h1>
          </div>
          <div className="row">
            <div className="m-t-20">
              <div className="alert alert-success">
                <h4 className="dns-change-required">
                  <strong>You&#39;re Almost There! </strong>
                  You must first enable text messaging to send SMS messages in
                  your workflows. <br />
                  <a href="https://leads.realgeeks.com/preferences/text_messaging">
                    Click here to enable text messaging.
                  </a>
                </h4>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return { sms: state.campaigns.sms };
}

export default connect(
  mapStateToProps,
  { fetchCampaignSMS, fetchRookeryStatusInfo }
)(CampaignSMSIndex);
